'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _formComponents = require('components/formComponents');

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubjectField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(SubjectField, _PureComponent);

  function SubjectField() {
    (0, _classCallCheck3.default)(this, SubjectField);
    return (0, _possibleConstructorReturn3.default)(this, (SubjectField.__proto__ || (0, _getPrototypeOf2.default)(SubjectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubjectField, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(_reduxForm.Field, {
        inputClassName: 'material',
        name: 'subject',
        type: 'text',
        noIndent: true,
        hideLabel: true,
        placeholder: t('Subject'),
        component: _formComponents.formSimpleTextInput,
        required: true
      });
    }
  }]);
  return SubjectField;
}(_react.PureComponent), _class2.propTypes = {
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = SubjectField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/SubjectField.js
// module id = 2082
// module chunks = 1